<template>
  <article class="page">
    <hero :extra="extra" :comments="extra.comments.length"></hero>
    <section class="postContent">
      <div class="container" v-html="extraContent">
      </div>
      <div class="container tags" v-if="extra.tags">
        <p>
          <strong>Tags:</strong>
          <span v-for="(tag, index) in extra.tags">
            <a :href="'/tag/' + tag.slug">
              <span v-html="tag.name"></span>
            </a>
            <span v-if="(index + 1) < extra.tags.length">, </span>
          </span>
        </p>
      </div>
    </section>
    <section class="postContent commentsContent">
      <div class="container">
        <comments :comments="extra.comments" :postId="extra.id"></comments>
      </div>
    </section>
  </article>
</template>

<script>
import Hero from '@/components/extra/Hero'
import Comments from '@/components/common/Comments'

export default {
  name: 'extra',
  props: ['extra'],
  components: {
    Hero,
    Comments
  },
  mounted () {
    window.instgrm.Embeds.process()
    window.twttr.widgets.load()
  },
  computed: {
    extraContent () {
      let vm = this
      if (vm.extra && vm.extra.content) {
        let content = vm.extra.content
        if (process.env.NODE_ENV === 'development') {
          content = content.split('src="http://longestshortesttime').join('src="http://cdn.longestshortesttime')
        }
        return content
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Extra.vue?1256bd08